import { createRouter, createWebHashHistory } from "vue-router";

const home = () => import("@/components/home");
const About = () => import("@/components/About");

// 店铺
const Shop = () => import("@/components/Shop");

// 我的绘画作品
const MyDrawing = () => import("@/components/MyDrawing");

// 书架
const BookList = () => import("@/components/BookList");

// 网络素材
const WebPhotos = () => import("@/components/WebPhotos");

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/WebPhotos",
    name: "WebPhotos",
    component: WebPhotos,
  },
  {
    path: "/BookList",
    name: "BookList",
    component: BookList,
  },
  {
    path: "/MyDrawing",
    name: "MyDrawing",
    component: MyDrawing,
  },
  {
    path: "/Shop",
    name: "Shop",
    component: Shop,
  },
  {
    path: "/About",
    name: "About",
    component: About,
  },
  {
    path: "/home",
    name: "home",
    component: home,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
